/* eslint-disable no-extend-native */
import moment from 'moment'

Date.prototype.momentFormat = function (f) {
  return moment(this).format(f ? moment.defaultFormat : f)
}
